import { gql } from "@apollo/client";

export default gql`
  extend type Mutation {
    updateProfileData(id: Int!): Boolean
  }
`;
